// Small shared helper for the pending-collaborator-claim flow.
//
// When an unauthenticated visitor clicks "Accept invite" on a public pipeline,
// we route them to /signup?claim=<token>. The signup page stashes the token
// in localStorage under PENDING_COLLAB_CLAIM_KEY. As soon as auth resolves
// anywhere in the app, the PendingCollabClaimModal picks it up, fetches the
// pipeline preview, and asks the user to confirm joining. On accept it calls
// POST /api/fundraise/pipelines/claim and clears the key.
//
// localStorage (not sessionStorage) is intentional: the auth round-trip can
// span multiple browser tabs (email confirmation link opens a new tab), so
// sessionStorage would lose the token.

export const PENDING_COLLAB_CLAIM_KEY = 'pending_collab_claim';

export const stashPendingClaim = (token: string): void => {
  try {
    localStorage.setItem(PENDING_COLLAB_CLAIM_KEY, token);
  } catch {
    // localStorage can throw in private-mode browsers; the modal flow just
    // doesn't fire and the user can re-open the link from the owner.
  }
};

export const readPendingClaim = (): string | null => {
  try {
    return localStorage.getItem(PENDING_COLLAB_CLAIM_KEY);
  } catch {
    return null;
  }
};

export const clearPendingClaim = (): void => {
  try {
    localStorage.removeItem(PENDING_COLLAB_CLAIM_KEY);
  } catch {
    // ignore
  }
};
